import { useState } from 'react';
import { FAQS } from '@/mocks/entertainment';
import SectionHeading from './SectionHeading';

export default function FaqSection() {
  const [open, setOpen] = useState(0);

  const ld = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: FAQS.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a },
    })),
  };

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(ld) }}
      />
      <div className="mx-auto max-w-6xl px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <SectionHeading
              eyebrow="常见问题"
              title="关于吃瓜八卦，你可能想问"
              desc="从内容来源到投稿方式，我们把大家最常问的问题集中作答。如果还有疑问，也欢迎通过页面底部的邮箱与我们联系。"
            />
            <div className="mt-6 flex flex-wrap gap-2.5">
              {['内容可溯源', '争议会跟进', '投稿有筛选'].map((s) => (
                <span
                  key={s}
                  className="inline-flex items-center gap-1.5 rounded-full border border-background-200 bg-background-100 px-3.5 py-2 text-sm text-foreground-700"
                >
                  <i className="ri-shield-check-line text-accent-600"></i>
                  {s}
                </span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="flex flex-col gap-3">
              {FAQS.map((f, i) => {
                const isOpen = open === i;
                return (
                  <div
                    key={f.q}
                    className={`overflow-hidden rounded-2xl border transition-colors ${
                      isOpen
                        ? 'border-primary-200 bg-primary-50/50'
                        : 'border-background-200/70 bg-background-50'
                    }`}
                  >
                    <button
                      type="button"
                      onClick={() => setOpen(isOpen ? -1 : i)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="font-heading text-base font-semibold text-foreground-950">
                        {f.q}
                      </span>
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-colors ${
                          isOpen ? 'bg-primary-500 text-background-50' : 'bg-background-100 text-foreground-500'
                        }`}
                      >
                        <i className={`${isOpen ? 'ri-subtract-line' : 'ri-add-line'} text-sm`}></i>
                      </span>
                    </button>
                    <div
                      className={`grid transition-all duration-300 ${
                        isOpen ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'
                      }`}
                    >
                      <div className="overflow-hidden">
                        <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                          {f.a}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}